import React from 'react';
import { DownloadIcon, GlobeIcon, ShieldCheckIcon } from 'lucide-react';
const sellos: Array<{
  icono: React.ComponentType<{
    className?: string;
  }>;
  texto: string;
}> = [{
  icono: DownloadIcon,
  texto: 'Descarga inmediata en PDF'
}, {
  icono: ShieldCheckIcon,
  texto: 'Garantía de 7 días'
}, {
  icono: GlobeIcon,
  texto: 'Disponible en toda LATAM'
}];
export function SiteFooter() {
  return <footer className="w-full bg-ink px-6 py-16 text-center text-white" data-id="element-198" data-mp="3dhe2jqoy22a7">
      <div className="mx-auto max-w-prose2" data-id="element-199" data-mp="3dei666sqvlnv">
        <p className="text-[11px] font-bold uppercase tracking-[0.24em] text-brand-300" data-id="element-200" data-mp="38gq9kzh5nbdc">Pago único</p>
        <p className="mt-3 font-display text-2xl font-bold sm:text-3xl" data-id="element-201" data-mp="33jq871v92wsk">Mega Pack Manicuria sin esclavitud</p>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/70" data-id="element-202" data-mp="2yl542rcvnsyu">
          Sistema digital de trabajo para manicuras, técnicas de uñas y dueñas de estética de toda LATAM.
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-8 gap-y-3" data-id="element-203" data-mp="wsqnbvm2kuk0">
          {sellos.map(sello => <li key={sello.texto} className="flex items-center gap-2 text-sm font-medium text-white/80" data-id="element-204" data-mp="15t81284mie71">
              <sello.icono className="h-4 w-4 text-brand-300" aria-hidden="true" data-id="element-205" data-mp="1anlqzv0int4b" />
              {sello.texto}
            </li>)}
        </ul>

        <div className="mt-10 border-t border-white/10 pt-6" data-id="element-206" data-mp="10sjxyo34e6wg">
          <p className="text-xs leading-relaxed text-white/50" data-id="element-207" data-mp="1ohmsgwiuru8d">
            © 2026 Mega Pack Manicuria sin esclavitud. Todos los derechos reservados. Los precios están expresados en dólares estadounidenses (USD) y se convierten automáticamente a tu moneda local al momento del pago.
          </p>
        </div>
      </div>
    </footer>;
}